import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  sessionWarningNotified: false,
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionWarningNotifiedResult(state, action: PayloadAction<any>) {
      state.sessionWarningNotified = action.payload;
    },
  },
});

export const { setSessionWarningNotifiedResult } = sessionSlice.actions;

export default sessionSlice.reducer;
